(function () {
  if (window.__nhHome) return;
  window.__nhHome = true;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-nh-reveal]:not(.is-in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.16 });
    els.forEach(function (el) { io.observe(el); });
  }

  function smoothstep(x, a, b) {
    var t = Math.min(1, Math.max(0, (x - a) / (b - a)));
    return t * t * (3 - 2 * t);
  }

  // Vídeo do estojo guiado pela rolagem: currentTime acompanha o progresso do scroll.
  function initHero(track) {
    if (track.__nhInit) return;
    track.__nhInit = true;
    var video = track.querySelector('video[data-nh-video]');
    var text = track.querySelector('[data-nh-text]');
    var hint = track.querySelector('[data-nh-hint]');
    if (!video || !text) return;

    if (reduceMotion) {
      var rest = function () { video.currentTime = Math.max(0, (video.duration || 5) - 0.05); };
      if (video.readyState >= 1) rest(); else video.addEventListener('loadedmetadata', rest);
      return;
    }

    track.classList.add('is-scrub');
    var ready = false, duration = 0, last = -1, ticking = false;

    function update() {
      var rect = track.getBoundingClientRect();
      var pin = track.firstElementChild;
      var range = track.offsetHeight - (pin ? pin.offsetHeight : window.innerHeight);
      var p = range > 0 ? Math.min(1, Math.max(0, -rect.top / range)) : 1;
      if (p === last) return;
      last = p;
      if (ready) {
        var t = p * (duration - 0.05);
        if (Math.abs(video.currentTime - t) > 0.02) video.currentTime = t;
      }
      var tp = smoothstep(p, 0.62, 0.94);
      text.style.opacity = tp;
      text.style.transform = 'translateY(' + (18 * (1 - tp)) + 'px)';
      if (hint) hint.style.opacity = 1 - smoothstep(p, 0, 0.06);
    }
    function tick() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }
    function prime() {
      // vídeo que nunca tocou não pinta frame só com currentTime: play()+pause() força o primeiro frame
      var pr = video.play();
      if (pr && pr.catch) pr.catch(function () {});
      video.pause();
    }
    function onMeta() {
      if (ready) return;
      duration = video.duration || 5;
      ready = true;
      prime();
      last = -1;
      update();
    }
    video.addEventListener('loadedmetadata', onMeta);
    if (video.readyState >= 1) onMeta();

    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick);
    tick();
  }

  function init(root) {
    (root || document).querySelectorAll('[data-nh-hero]').forEach(initHero);
    initReveal(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
